import { API_BASE_URL } from "../../../config";
import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const UserDataRegister = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [number, setNumber] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate = useNavigate();

    const checkToken = useCallback(() => {
        const user = localStorage.getItem("user");
        if (!user) {
            navigate("/login");
            return null;
        }
        return JSON.parse(user)?.token;
    }, [navigate]);

    const handleRegister = async () => {
        setError("");
        setSuccess("");

        if (!firstName || !lastName || !number) {
            setError("All fields are required.");
            return;
        }

        const token = checkToken();
        if (!token) return;

        try {
            // Feature disabled: /api/Manager/ is no longer usable
            /*
            const response = await fetch(`${API_BASE_URL}/api/Manager/userData`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ firstName, lastName, number })
            });

            if (response.ok) {
                const data = await response.json();
                setSuccess("User data registration successful!");
                setFirstName("");
                setLastName("");
                setNumber("");
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Registration failed. Please try again.");
            }
            */
           setError("Registration is currently disabled.");
        } catch (error) {
            console.error("Registration error:", error);
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <div className="registerContainer">
            <h1>User Data Register</h1>
            <button onClick={() => navigate('/register')} className="backButton">
                กลับ
            </button>
            <br/>
            <br/>

            <div className="inputContainer">
                <input
                    type="text"
                    value={firstName}
                    placeholder="First Name"
                    onChange={e => setFirstName(e.target.value)}
                />
            </div>
            <div className="inputContainer">
                <input
                    type="text"
                    value={lastName}
                    placeholder="Last Name"
                    onChange={e => setLastName(e.target.value)}
                />
            </div>
            <div className="inputContainer">
                <input
                    type="text"
                    value={number}
                    placeholder="Number"
                    onChange={e => setNumber(e.target.value)}
                />
            </div>

            <br/>
            <div className="inputContainer">
                <button className="btc-register-button" onClick={handleRegister}>บันทึก</button>
            </div>
            {error && <p className="errorMessage">{error}</p>}
            {success && <p className="successMessage">{success}</p>}
        </div>
    );
};

export default UserDataRegister;
